import { useEffect, useRef, useState } from 'react';
import Tooltip, { defaultStyles } from './Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TRANSLATE = 'translate(0%, -100%)';
function TooltipWithBounds(_ref) {
  let {
    children,
    style,
    left: initialLeft = 0,
    offsetLeft = 2,
    offsetTop = -2,
    top: initialTop = 0,
    unstyled = false,
    ...otherProps
  } = _ref;
  const elementRef = useRef(null);
  const [transformStyle, setTransformStyle] = useState(DEFAULT_TRANSLATE);
  useEffect(() => {
    var _elementRef$current;
    const rect = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.getBoundingClientRect();
    if (rect) {
      const outOfViewTop = Math.min(0, initialTop - rect.height);
      const outOfViewRight = Math.max(0, initialLeft + rect.width - window.innerWidth);
      const translateX = outOfViewRight > 0 ? -rect.width : 0;
      const translateY = outOfViewTop < 0 ? 0 : -rect.height;
      setTransformStyle(`translate(${translateX}px, ${translateY}px )`);
    }
  }, [initialTop, initialLeft, elementRef]); // Dependency on adjusted state

  return /*#__PURE__*/_jsx(Tooltip, {
    ref: elementRef,
    style: {
      top: initialTop + offsetTop,
      left: initialLeft + offsetLeft,
      transform: transformStyle,
      ...defaultStyles,
      ...(!unstyled && style)
    },
    ...otherProps,
    children: children
  });
}
export default TooltipWithBounds;